import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from '../UI/Button';
import { useTranslation } from 'react-i18next';
import { getLanguagePathPrefix } from '../../i18n';

export const OfficeCTA: React.FC = () => {
  const { t } = useTranslation(['common', 'office']);
  
  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background Video - Office atmosphere */}
      <video
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        className="absolute inset-0 w-full h-full object-cover z-0"
      >
        <source src="/images/blog/office2.mp4" type="video/mp4" />
      </video>
      {/* Overlay léger pour lisibilité du texte */}
      <div className="absolute inset-0 z-[1] bg-black/40" />
      
      {/* Content */}
      <div className="relative z-[2] max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)]">
            {t('office:cta.title')}
          </h2>
          <p className="text-xl md:text-2xl font-semibold text-yellow-400 mb-4 italic drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)]">
            {t('office:cta.slogan')}
          </p>
          <p className="text-xl text-white/90 max-w-3xl mx-auto mb-8 drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">
            {t('office:cta.subtitle')}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <div className="flex items-center space-x-2 text-white">
              <CheckCircle className="h-5 w-5 drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]" />
              <span className="drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">{t('common:cta.features.freeTrial')}</span>
            </div>
            <div className="flex items-center space-x-2 text-white">
              <CheckCircle className="h-5 w-5 drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]" />
              <span className="drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">{t('common:cta.features.support')}</span>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg" 
              variant="glossy"
              className="rounded-full px-8 shadow-[0_4px_16px_rgba(0,0,0,0.8)]"
              icon={ArrowRight}
              onClick={() => { 
                const lp = getLanguagePathPrefix();
                window.location.href = `${lp}/office/pricing/?product=prod_SeK3hvbM1hFsMI`;
              }}
            >
              {t('common:cta.startNow')}
            </Button>
            <Button 
              size="lg" 
              variant="ghost" 
              className="text-white hover:bg-white/10 border border-white/30 shadow-[0_4px_16px_rgba(0,0,0,0.8)]"
              onClick={() => { 
                window.location.href = `${getLanguagePathPrefix()}/contact`;
              }}
            >
              {t('common:cta.viewDemo')}
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};